
require('./myProfileExtractsView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const Immutable = require('immutable');
// @ actions
import documentActions from 'actions/documents';
import okApiDocuments from 'actions/okApiDocuments';
import additionalDocumentActions from 'actions/additionalDocumentation';
const { okInsuranceActions: { InsurancesProfileDocumentation, insuranceRequestLanding, insuranceRequestState } } = require('ok-insurance');
// @ components
const ExtractsMenu = require('components/myProfile/myProfileExtractsView/myProfileExtractsMenu/myProfileExtractsMenu');
const ExtractsList = require('components/myProfile/myProfileExtractsView/myProfileExtractsList/myProfileExtractsList');
const ExtractsFilter = require('components/myProfile/extractsFilter/extractsFilter');
const MyProfileDocumentationMoreOptionsButton = require('components/myProfile/myProfileDocumentationMoreOptionsButton/myProfileDocumentationMoreOptionsButton');
// @ constants
const DOCUMENTS_GROUPS = require('constants/documentsGroups');
import { FISCAL_INFORMATION } from 'constants/index';
// @ commons
import { recordLinkV2 } from 'utilities/tagging';
const { FormattedText, formatText } = require('core/i18n').i18n;
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { VIEWER } = require('constants/contactCenter/pdfViewer');

class MyProfileExtractsView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            filterSettingsOpen: false,
            isOpenEmailSentModal: false
        }
        this.handleExtractGroupChange = this.handleExtractGroupChange.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.onSetFilter = this.onSetFilter.bind(this);
        this.handleGoToContracts = this.handleGoToContracts.bind(this);
        this.callbackDownloadFile = this.callbackDownloadFile.bind(this);
        this.callbackDownloadFiscalFile = this.callbackDownloadFiscalFile.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
        this.handleResetFilter = this.handleResetFilter.bind(this);
        this.callbackDownloadMifid2File = this.callbackDownloadMifid2File.bind(this);
        this.handleOpenPDFViewer = this.handleOpenPDFViewer.bind(this);
        this.callbackSendMifid2DocumentByEmail = this.callbackSendMifid2DocumentByEmail.bind(this);
        this.downloadById = this.downloadById.bind(this);
    }

    componentDidMount() {
        this.props.resetDocuments();
        this.props.requestMoreDocuments();
        this.props.requestAdditionalDocumentation(FISCAL_INFORMATION);
    }

    componentWillUnmount() {
        const { clearFilters, clearInsurancesOverallView } = this.props;
        clearFilters();
        clearInsurancesOverallView();
    }

    callbackSendMifid2DocumentByEmail(params) {
        this.props.sendMifid2DocumentByEmail(params);
    }

    /**
     * we only set "isFiltering" when we set filters to remove old documents.
     */

    onSetFilter(filters) {
        this.props.setFilter(filters);
        this.props.requestMoreDocuments();
    }


    downloadById (documentId) {
        this.props.getDocumentsOkApiById(documentId)
      }

    handleFilterButtonClick = () =>{
        recordLinkV2({
            categoriaEvento: `documentos/${formatText(`groupNames-${this.props.immDocuments.get('groupSelected')}`)}`,
            accionEvento: "filtro",
            etiquetaEvento: "abrir"
        })

        this.handleToggleFilters()
    }

    buildContractsView() {
        const {
            immAccounts,
            immDocuments,
            additionalDocuments,
            requestMoreDocuments,
            getContractedDocument,
            immInsurances,
            insurancesProfileDocumentation,
            immFlagBasedFeatures,
            setSelectedDocument,
            mifid2DocumentSendEmailReset,
        } = this.props;
        const groupSelected = immDocuments.get('groupSelected');
        const immFilters = immDocuments.get('filters');
        const isInsuranceFlagEnabled = immFlagBasedFeatures.get('home-insurance-enabled');

        let documents = immDocuments.get('documents');
        let documentsByGroup = immDocuments.get('documentsByGroup');
        let documentList;

        documents = this.buildDocumentsData(documents);
        const filterSettingsButton = groupSelected !== '0022' ? (
            <OKButton modifier="task" onClick={this.handleFilterButtonClick}>
                <i className="icon-filtrar" />
            </OKButton>
        ) : null;

        if (immDocuments.get('error') && additionalDocuments.get('error')) {
            documentList = this.buildErrorState();
        } else {
            documentList = (
                <div className="extracts_view">
                    <div className="extracts-view__filter-settings-button">
                        {filterSettingsButton}
                    </div>
                    <div className="extracts-view__document-list-section">
                        <ExtractsList
                            downloadById={this.downloadById}
                            callbackDownloadFile={this.callbackDownloadFile}
                            callbackDownloadFiscalFile={this.callbackDownloadFiscalFile}
                            documents={documents}
                            additionalDocuments={additionalDocuments}
                            documentsByGroup={documentsByGroup}
                            filters={immFilters}
                            groupSelected={groupSelected}
                            immAccounts={immAccounts}
                            callbackDownloadMifid2File={__CONTACT_CENTER__ ? this.handleOpenPDFViewer : this.callbackDownloadMifid2File}
                            callbackSendMifid2DocumentByEmail={this.callbackSendMifid2DocumentByEmail}
                            mifid2DocumentSendEmailReset={mifid2DocumentSendEmailReset}
                            isPartialFetching={immDocuments.get('isPartialFetching')}
                            onClearFilter={this.handleClearFilters}
                            onResetFilter={this.handleResetFilter}
                            requestMoreDocuments={requestMoreDocuments}
                            showAutoDates
                            mifid2DocumentByEmailError={__CONTACT_CENTER__ && immDocuments.get('emailError')}
                            immInsurances={immInsurances}
                            callbackDownloadFileInsurances={getContractedDocument}
                            documentDownloadingPolicyNumber={insurancesProfileDocumentation.get('documentDownloadingPolicyNumber')}
                            documentsFetch={insurancesProfileDocumentation.get('documentsFetch')}
                            setSelectedDocument={setSelectedDocument}
                            isFetchingContactCenterDocuments={__CONTACT_CENTER__ && immDocuments.get('isFetchingContactCenterDocuments')}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="grid-view__body">
                <div className="row no-outside-gutter">
                    <div className="col-xs-4">
                        <ExtractsMenu
                            onGroupChange={this.handleExtractGroupChange}
                            groupSelected={groupSelected}
                            requestMoreDocuments={requestMoreDocuments}
                            documentsByGroup={immDocuments.get('documentsByGroup')}
                            isInsuranceFlagEnabled={isInsuranceFlagEnabled}
                        />
                    </div>
                    <div className="col-xs-8">
                        <ExtractsFilter
                            documents={documents}
                            groupSelected={groupSelected}
                            immFilter={immFilters}
                            isOpen={this.state.filterSettingsOpen}
                            onCloseClick={this.handleToggleFilters}
                            setFilter={this.onSetFilter}
                        />
                        {documentList}
                    </div>
                </div>
            </div>
        );
    }

    buildDocumentsData(immDocuments) {
        let obj = [];

        if (immDocuments) {
            immDocuments.map(immDocument => {
                let doc = immDocument.toJS();
                doc.file = {
                    filename: `${immDocument.get('nombreTipoComunicacion')}.pdf`,
                    gestorDocumental: immDocument.get('gestorDocumental'),
                    codSubaplicacion: immDocument.get('codSubaplicacion'),
                    codComunicacion: immDocument.get('codComunicacion')
                };
                obj.push(doc);
            });
        }

        return Immutable.fromJS(obj);
    }

    buildErrorState() {
        const errorMessage = formatText('profileExtracts-errorMessage');
        const handleRequestDocuments = this.props.requestMoreDocuments;

        const retryButton = (
            <OKButton
                id="btn_myProfileAdditionalDocumentationView_retry"
                onClick={handleRequestDocuments}
            >
                <FormattedText value="profileExtracts-retry" />
            </OKButton>
        );

        return (
            <OKSectionBox className="extracts_view">
                <EmptyState
                    button={retryButton}
                    primaryText={errorMessage}
                    iconType="nointernet-banking" />
            </OKSectionBox>
        );
    }

    callbackDownloadFile(props) {
        recordLinkV2({
            categoriaEvento: `documentos/${formatText(`groupNames-${this.props.immDocuments.get('groupSelected')}`)}`,
            accionEvento: "descargar",
            etiquetaEvento: props.filename
        })

        this.props.requestDocumentsPdf({
            filename: props.filename,
            gestorDocumental: props.gestorDocumental,
            codigoSubaplicacion: props.codSubaplicacion,
            codComunicacion: props.codComunicacion
        });
    }

    callbackDownloadFiscalFile(params, filename) {
        recordLinkV2({
            categoriaEvento: `documentos/${formatText(`groupNames-${this.props.immDocuments.get('groupSelected')}`)}`,
            accionEvento: "descargar",
            etiquetaEvento: "Informe fiscal"
        })

        this.props.getFileSaddeDocuments(params, filename)
    }

    callbackDownloadMifid2File(props) {
        recordLinkV2({
            categoriaEvento: `documentos/${formatText(`groupNames-${this.props.immDocuments.get('groupSelected')}`)}`,
            accionEvento: "descargar",
            etiquetaEvento: props.translatedDocumentType
        })

        this.props.requestMifid2DocumentsPdf({
            codComunicacion: props.codComunicacion,
            fileName: props.fileName
        });
    }

    handleOpenPDFViewer(props) {
        this.props.requestMifid2DocumentsPdf({
            codComunicacion: props.codComunicacion
        }, VIEWER);
    }

    existGrup(document) {
        return DOCUMENTS_GROUPS.some((group) => {
            return group.codGrupo === document.get('codGrupoComunicacion');
        });
    }

    /**
     * we only set "isFiltering" when we set filters to remove old documents.
     */

    handleClearFilters() {
        this.props.clearFilters();
        this.props.requestMoreDocuments();
    }

    handleExtractGroupChange(groupId) {
        const { getInsurance, immInsurances, requestInsurancesOverallView, clearInsurancesOverallView } = this.props;
        if (immInsurances.get('insurances').size) {
            clearInsurancesOverallView();
        }
        if (groupId === '0022') {
            getInsurance();
            requestInsurancesOverallView();
        }

        recordLinkV2({
            categoriaEvento: `documentos/${formatText(`groupNames-${this.props.immDocuments.get('groupSelected')}`)}`,
            accionEvento: "menu/grupos",
            etiquetaEvento: formatText(`groupNames-${groupId}`)
        })

        this.props.setGroupSelected(groupId);
    }

    handleGoToContracts() {
        recordLinkV2({
            categoriaEvento: `documentos/${formatText(`groupNames-${this.props.immDocuments.get('groupSelected')}`)}`,
            accionEvento: "contratos en vigor"
        });
        this.props.history.push('/myprofile/documentation/contracts');
    }

    handleResetFilter(filterKey) {
        this.props.resetFilter(filterKey);
        this.props.requestMoreDocuments();
    }

    handleToggleFilters() {
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        });
    }

    render() {
        const { children, immDocuments } = this.props;
        let content;
        const title = formatText('landingHeader-documentation');
        if (immDocuments.get('isFetchingGroups')) {
            content = (
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="pg">
                            <OKHeaderLanding title={title}>
                                <MyProfileDocumentationMoreOptionsButton />
                                <div className="extracts-view__contracts-primary-button">
                                    <OKButton modifier="primary" onClick={this.handleGoToContracts}>
                                        <FormattedText value="profileDocumentation-boxButton" />
                                    </OKButton>
                                </div>
                            </OKHeaderLanding>
                        </OKCover>
                        <LoadingSection />
                    </div>
                </div>
            )
        } else {
            if (!children) {
                const contractsContent = this.buildContractsView();
                content = (
                    <React.Fragment>
                        <div className="container-fluid">
                            <div className="row">
                                <OKCover size="small" section="pg" customClass="col-xs-12">
                                    <OKHeaderLanding title={title}>
                                        <MyProfileDocumentationMoreOptionsButton />
                                        <div className="extracts-view__contracts-primary-button">
                                            <OKButton modifier="primary" onClick={this.handleGoToContracts}>
                                                <FormattedText value="profileDocumentation-boxButton" />
                                            </OKButton>
                                        </div>
                                    </OKHeaderLanding>
                                </OKCover>
                            </div>
                        </div>
                        <div className="grid-view__body">
                            <div className="container-fluid grid-view--content-position-positive">
                                {contractsContent}
                            </div>
                        </div>
                    </React.Fragment>
                );
            } else {
                content = (
                    <div className="container-fluid">
                        <div className="row">
                            {children}
                        </div>
                    </div>
                );
            }
        }
        return content;
    }
}

MyProfileExtractsView.propTypes = {
    children: PropTypes.object,
    clearFilters: PropTypes.func.isRequired,
    immDocuments: PropTypes.object,
    additionalDocuments: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    requestDocumentsPdf: PropTypes.func.isRequired,
    getFileSaddeDocuments: PropTypes.func.isRequired,
    requestMoreDocuments: PropTypes.func.isRequired,
    requestAdditionalDocumentation: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    requestMifid2DocumentsPdf: PropTypes.func.isRequired,
    sendMifid2DocumentByEmail: PropTypes.func.isRequired,
    mifid2DocumentSendEmailReset: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    getDocumentsOkApiById: PropTypes.func.isRequired,
    setGroupSelected: PropTypes.func.isRequired,
    resetDocuments: PropTypes.func.isRequired,
    immInsurances: PropTypes.object.isRequired,
    clearInsurancesOverallView: PropTypes.func.isRequired,
    requestInsurancesOverallView: PropTypes.func.isRequired,
    getContractedDocument: PropTypes.func,
    getInsurance: PropTypes.func.isRequired,
    insurancesProfileDocumentation: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    setSelectedDocument: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = MyProfileExtractsView;

module.exports.MyProfileExtractsView = connect(state => ({
    immAccounts: state.accounts,
    immDocuments: state.documents,
    additionalDocuments: state.additionalDocumentation,
    immInsurances: state.insuranceRequestLanding,
    insurancesProfileDocumentation: state.insurancesProfileDocumentation,
    immFlagBasedFeatures: state.flagBasedFeatures
}), {
        resetDocuments: documentActions.resetDocuments,
        requestAdditionalDocumentation: additionalDocumentActions.requestAdditionalDocumentation,
        requestMoreDocuments: documentActions.requestMoreDocuments,
        getDocumentsOkApiById:okApiDocuments.getDocumentsOkApiById,
        requestDocumentsPdf: documentActions.requestDocumentsPdf,
        getFileSaddeDocuments: additionalDocumentActions.getFileSaddeDocuments,
        requestMifid2DocumentsPdf: documentActions.requestMifid2DocumentsPdf,
        sendMifid2DocumentByEmail: documentActions.sendMifid2DocumentByEmail,
        mifid2DocumentSendEmailReset: documentActions.mifid2DocumentSendEmailReset,
        setFilter: documentActions.setDocumentsFilter,
        clearFilters: documentActions.clearDocumentsFilter,
        setGroupSelected: documentActions.setGroupSelected,
        resetFilter: documentActions.resetDocumentsFilter,
        setSelectedDocument: documentActions.setSelectedDocument,
        getInsurance: insuranceRequestState.requestInsuranceCurrentState,
        requestInsurancesOverallView: insuranceRequestLanding.requestInsurancesOverallView,
        clearInsurancesOverallView: insuranceRequestLanding.clearInsurancesOverallView,
        getContractedDocument: InsurancesProfileDocumentation.getContractedDocument,
    })(withRouter(MyProfileExtractsView));
